import { Chip } from '@mui/material';
import { ReactElement, useMemo } from 'react';
import { OrdersCategories } from '../state/state';

type OrderCategoryChipProps = {
  label: string;
  selectedCategory: OrdersCategories;
  category: OrdersCategories;
  onClick: (category: OrdersCategories) => void;
  icon?: ReactElement;
}

export default function OrderCategoryChip({ label, category, selectedCategory, onClick, icon }: OrderCategoryChipProps): React.JSX.Element {
  const isChipSelected = useMemo(() => (
    selectedCategory === category
  ), [selectedCategory, category]);

  return (
    <Chip
      label={label}
      icon={icon}
      variant="filter"
      className={isChipSelected ? 'Kheops-selected' : ''}
      onClick={() => onClick(category)}
    />
  );
}
